import React from 'react';
import './LoadingErrorState.css';

export function LoadingErrorState({ loading, loadingText = 'Wird geladen…', error, children }) {
  if (loading) return <p aria-busy="true">{loadingText}</p>;
  if (error) return <div role="alert" className="error-message">{error}</div>;
  return <>{children}</>;
}
